import DoneAllIcon from '@mui/icons-material/DoneAll';
import ErrorIcon from '@mui/icons-material/Error';
import Typography from '@mui/material/Typography';
import React from 'react';

import { SUCCESS } from 'constants/index';

import { styles } from './styles';

const PaymentStatusResult = ({ status }) => {
	if (status === SUCCESS) {
		return (
			<Typography component={'span'} sx={styles.paymentResult} color="primary" variant="h6">
				<DoneAllIcon fontSize={'large'} />
				Payment Processed
			</Typography>
		);
	}

	return (
		<Typography component={'span'} sx={styles.paymentResult} color="error" variant="h6">
			<ErrorIcon fontSize={'large'} />
			Payment Failed
		</Typography>
	);
};

export default PaymentStatusResult;
